/**
 * Facebook JS SDK Loader & Initializer
 * Loads the official Facebook SDK dynamically for Facebook Login authentication.
 */
export const initFacebookSDK = () => {
  return new Promise((resolve) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: process.env.REACT_APP_META_APP_ID || '2437436126750308',

        cookie: true,
        xfbml: true,
        version: 'v25.0',

      });
      resolve(window.FB);
    };

    // Load SDK asynchronously
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  });
};

/**
 * Trigger Facebook Login Popup with requested permission scopes
 */
export const loginWithFacebook = () => {
  return new Promise((resolve, reject) => {
    initFacebookSDK().then((FB) => {
      FB.login(
        (response) => {
          if (response.authResponse) {
            resolve({
              accessToken: response.authResponse.accessToken,
              userID: response.authResponse.userID,
              expiresIn: response.authResponse.expiresIn,
              signedRequest: response.authResponse.signedRequest,
            });
          } else {
            reject(new Error('User cancelled Facebook login or did not fully authorize'));
          }
        },
        {
          scope:
            'pages_show_list,pages_read_engagement,pages_manage_posts,instagram_basic,instagram_content_publish,ads_management,leads_retrieval',

          return_scopes: true,
        }
      );
    });
  });
};
